import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import SharedIcon from '../sharedIcon';
import ConditionalTooltip from '../conditionalTooltip';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  label: {
    color: primary.bluish3,
    lineHeight: '20px',
    marginBottom: spacing(2),
  },
  tooltip: {
    width: 'fit-content',
  },
  type: {
    display: 'flex',
    alignItems: 'center',
  },
  typeWithName: {
    border: `1px solid ${primary.bluish1}`,
    borderRadius: 4,
    padding: spacing(0, 2),
    height: 20,
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  typeIcon: {
    width: 16,
    height: 16,
    marginRight: spacing(1),
  },
  name: {
    fontSize: 10,
    lineHeight: '12px',
    textTransform: 'uppercase',
    userSelect: 'none',
  },
}));

const SurveyType = ({
  className = '',
  tooltipClass = '',
  typeIconClass = '',
  label = '',
  type,
  hasTooltip = false,
  isIconStatus = false,
}) => {
  const classes = useStyles();

  return (
    <div className={className}>
      {label && (
        <Typography className={classes.label} variant="body2">
          {label}
        </Typography>
      )}
      <ConditionalTooltip
        className={classNames(classes.tooltip, tooltipClass)}
        addTooltip={hasTooltip || isIconStatus}
        message={isIconStatus ? type.name : type.explanation}
      >
        <div
          className={classNames(classes.type, {
            [classes.typeWithName]: !isIconStatus,
          })}
        >
          <SharedIcon
            customIconWrapperClass={classes.iconWrapper}
            iconConfig={{
              className: classNames(classes.typeIcon, typeIconClass),
            }}
            icon={type.icon}
            showIcon
          />
          {!isIconStatus && (
            <Typography className={classes.name} variant="overline">
              {type.name}
            </Typography>
          )}
        </div>
      </ConditionalTooltip>
    </div>
  );
};

SurveyType.propTypes = {
  className: PropTypes.string,
  tooltipClass: PropTypes.string,
  typeIconClass: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.shape({}).isRequired,
  hasTooltip: PropTypes.bool,
  isIconStatus: PropTypes.bool,
};

export default SurveyType;
